export default "__VITE_ASSET__BqEO8kx8__"